import React from "react";
import "./Footer.css";
import social1 from "../../Assets/Images/instagram.svg";
import social2 from "../../Assets/Images/youtube.svg";
import social3 from "../../Assets/Images/square-facebook.svg";
import social4 from "../../Assets/Images/pinterest-p.svg";
import social5 from "../../Assets/Images/twitter.svg";
import social6 from "../../Assets/Images/linkedin-in.svg";
import watsapp from "../../Assets/Images/watsapp.svg";

import CountryDropdown from 'country-dropdown-with-flags-for-react';


export default function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-top">
                    <div className="footer-left">
                        <h5 className="footer-title">CONNECT WITH US ON SOCIAL.</h5>
                        <ul className="social-list">
                            <li className="social-item">
                                <a href="#" className="social-link">
                                    <img src={social1} alt="social1" />
                                </a>
                            </li>
                            <li className="social-item">
                                <a href="#" className="social-link">
                                    <img src={social2} alt="social1" />
                                </a>
                            </li>
                            <li className="social-item">
                                <a href="#" className="social-link">
                                    <img src={social3} alt="social1" />
                                </a>
                            </li>
                            <li className="social-item">
                                <a href="#" className="social-link">
                                    <img src={social4} alt="social1" />
                                </a>
                            </li>
                            <li className="social-item">
                                <a href="#" className="social-link">
                                    <img src={social5} alt="social1" />
                                </a>
                            </li>
                            <li className="social-item">
                                <a href="#" className="social-link">
                                    <img src={social6} alt="social1" />
                                </a>
                            </li>
                            <li className="social-item"></li>
                        </ul>
                        <div className="footer-country">
                            <h6 className="footer-subtitle">
                                COUNTRYT/REGION
                            </h6>
                            <CountryDropdown id="UNIQUE_ID" className='YOUR_CSS_CLASS' preferredCountries={['gb', 'us']} value="" handleChange={e => console.log(e.target.value)}></CountryDropdown>

                        </div>
                    </div>
                    <div className="footer-right">
                        <ul className="footer-list">
                            <h3 className="footer-name">
                                Our company
                            </h3>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Mission
                                </a>
                            </li>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Vision
                                </a>
                            </li>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Investors
                                </a>
                            </li>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Careers
                                </a>
                            </li>
                        </ul>
                        <ul className="footer-list">
                            <h3 className="footer-name">
                                Our Range
                            </h3>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Rice
                                </a>
                            </li>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Wheat
                                </a>
                            </li>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Pulses
                                </a>
                            </li>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Cereals
                                </a>
                            </li>
                        </ul>
                        <ul className="footer-list">
                            <h3 className="footer-name">
                                OUR QUALITY                </h3>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Private label
                                </a>
                            </li>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Job work
                                </a>
                            </li>

                        </ul>
                        <ul className="footer-list">
                            <h3 className="footer-name">
                                GET IN TOUCH              </h3>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    FaQs            </a>
                            </li>
                            <li className="footer-item">
                                <a href="#" className="footer-link">
                                    Contact us            </a>
                            </li>

                        </ul>
                    </div>

                </div>
                <hr className="footer-hr" />
                <div className="footer-bottom">
                    <p className="footer-info">
                    2022 Be Natural Organics foods and cereals. All Rights Reserved.
                    </p>
                    <div className="footer-box">
                     <div className="footer-left-box">   <a href="#" className="footer-sublink">
                        Terms Of Use
                        </a>
                        <a href="#" className="footer-sublink">
                        Privacy Policy                        </a>
                    </div>
                    <div className="footer-right-box">
                        <a href="tel:+99890123456" className="footer-sublink">
                         <img src={watsapp} alt="watsapp" />   +99890123456</a></div></div>
                </div>
            </div>
        </footer>
    );
}
